import { logEvent } from "react-migration/lib/util/logEvent";
import { comparablesStore } from "../store";
import { ComparablesState } from "react-migration/domains/comparables/typings/Comparables";
import { PriceTypes } from "react-migration/domains/comparables/typings/PriceTypes";
import {
  PerAreaPriceModes,
  PerUnitPriceModes,
  ZooplaPricePerAreaModes,
  ZooplaPricePerUnitModes,
} from "react-migration/domains/comparables/typings/PriceModes";
import { updateSelection } from "../../map/actions/updateSelection";

// TODO: Remove this when we've migrated to the new store
export const setFilters = (filters: ComparablesState["filters"]) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  comparablesStore.filters = filters;
};

export const setHmlrFilters = (filters: ComparablesState["hmlrFilters"]) => {
  comparablesStore.hmlrFilters = filters;
};

export const setHometrackFilters = (filters: ComparablesState["hometrackFilters"]) => {
  comparablesStore.hometrackFilters = filters;
};

export const setFiltersOpen = (filtersOpen: ComparablesState["filtersOpen"]) => {
  comparablesStore.filtersOpen = filtersOpen;
};

export const setDataSource = (dataSource: ComparablesState["dataSource"]) => {
  comparablesStore.dataSource = dataSource;

  const priceType = comparablesStore.priceType;

  const zooplaDefaults = {
    [PriceTypes.PER_UNIT]: ZooplaPricePerUnitModes.VAL_ESTIMATE,
    [PriceTypes.PER_AREA]: ZooplaPricePerAreaModes.VAL_ESTIMATE,
  };
  const hmlrDefaults = {
    [PriceTypes.PER_UNIT]: PerUnitPriceModes.PRICE,
    [PriceTypes.PER_AREA]: PerAreaPriceModes.PPSM,
  };

  if (comparablesStore.dataSource === "hmlr") {
    comparablesStore.priceMode = hmlrDefaults[priceType];
  } else {
    comparablesStore.priceMode = zooplaDefaults[priceType];
  }
};

export const setPriceMode = (priceMode: ComparablesState["priceMode"]) => {
  updateSelection();
  comparablesStore.priceMode = priceMode;
};

export const setPriceSource = (priceSource: ComparablesState["priceSource"]) => {
  comparablesStore.priceSource = priceSource;
};

export const setPriceType = (priceType: ComparablesState["priceType"]) => {
  comparablesStore.priceType = priceType;
};

export const setSmallUnitSize = (smallUnitSize: ComparablesState["smallUnitSize"]) => {
  comparablesStore.smallUnitSize = smallUnitSize;
  logEvent("Comparables Unit Size", { smallUnitSize, priceMode: comparablesStore.priceMode });
};

export const setIncNoFloorArea = (incNoFloorArea: ComparablesState["incNoFloorArea"]) => {
  comparablesStore.incNoFloorArea = incNoFloorArea;
  logEvent("Comparables Inc No Floor Area", {
    include: incNoFloorArea,
    priceMode: comparablesStore.priceMode,
  });
};

export const setRHPdisplayBy = (RHPdisplayBy: ComparablesState["RHPdisplayBy"]) => {
  comparablesStore.RHPdisplayBy = RHPdisplayBy;
};
